// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--U9p_O","dialog-title":"dialog-title--_LUIW","dialog-content":"dialog-content--ga8WV"};